var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.406 13.12a3 3 0 1 1 4.242 4.243L22.263 35.748a3 3 0 0 1-4.242 0l-.018-.02-9.881-9.88a3 3 0 1 1 4.242-4.243l7.778 7.779z"
  })));
};
export default SvgIconCheck;